import React from 'react';
import Heading from '../../components/common/Typography/Heading';
import Paragraph from '../../components/common/Typography/Paragraph';
import {
  PUBLIC_ABOUT_COLUMN_GAP_CLASS,
  PUBLIC_HEADING_TO_CONTENT_CLASS,
} from '../Public/shared/publicLayoutSpec';

const OurStory = () => {
  return (
    <section className="tp-container-main px-10 mx-auto">
      <div className={`grid grid-cols-1 lg:grid-cols-2 ${PUBLIC_ABOUT_COLUMN_GAP_CLASS} items-start`}>
        {/* Column 1 - Title */}
        <div className="lg:sticky lg:top-8">
        <Heading variant={"h2"} className={"font-extrabold text-offblack leading-none"}>
            OUR STORY
          </Heading>
        </div>
        
        {/* Column 2 - Content */}
        <div className={`space-y-5 ${PUBLIC_HEADING_TO_CONTENT_CLASS} lg:mt-0`}>
          <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
              Trades Poster started in Melbourne after running our own small waterproofing business. We saw how hard it was for people to find proper tradies — and how hard it was for good businesses to get noticed.
          </Paragraph>
          <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
            Homeowners were often left dealing with taskers who did a bit of everything but didn't specialise. At the same time, tradies were stuck dealing with lead fees, bidding systems, and fake quote requests that wasted time and money.
          </Paragraph>
          <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
            That's why we built Trades Poster — a straightforward platform where people can find licensed, qualified, and verified tradies, and businesses can grow without the usual hassle.
          </Paragraph>
          <Paragraph variant={"MainParagraph"} className={"text-offblack"}>
            We're improving things every day — adding new tools, clearer guides, and smarter features to make the process easier for everyone. And there's more on the way.
          </Paragraph>
        </div>
      </div>
    </section>
  );
};

export default OurStory; 